import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { ColDef, ColGroupDef } from 'ag-grid-community/dist/lib/entities/colDef';

import { BaseInlineFormComponent } from '../../base-inline-form/base-inline-form.component';
import { GridComponent } from '../grid/grid.component';
import { FormlyButtonDropdown, GridRowSelect } from '../../../models';
import { BaseImportService, FormlyService, MenuService } from '../../../services';

@Component({
  selector: 'app-tab-grid',
  templateUrl: './tab-grid.component.html',
  styleUrl: './tab-grid.component.scss',
})
export class TabGridComponent implements OnInit {
  @ViewChild(GridComponent, { static: true }) grid: GridComponent;
  @ViewChild(BaseInlineFormComponent) form: BaseInlineFormComponent;

  @Input() stateKey: string;
  @Input() additionalFields: FormlyFieldConfig[] = [];
  @Input() columnDefs?: (ColDef | ColGroupDef)[] = [];
  @Input() importService: BaseImportService;
  @Input() importButtonText = $localize`Import`;
  @Input() dropDownText = $localize`Download Template`;
  @Input() fields: FormlyFieldConfig[] = [];
  @Input() filter = true;
  @Input() gridCssClass: string;
  @Input() header: string;
  @Input() name: string;
  @Input() pagination = true;
  @Input() rowData: any = [];
  @Input() multiSelectRows = true;
  @Input() showCreate = true;
  @Input() showDelete = true;
  @Input() showDiscard = true;
  @Input() showExport = true;
  @Input() sortable = true;
  @Input() leftHeader = false;
  @Input() fullWidth = false;
  @Input() createDropdown: FormlyButtonDropdown;
  @Input() importDropdown: FormlyButtonDropdown;
  @Input() model = {};
  @Input() submitText = '';
  @Input() submitIcon = '';
  @Input() suppressScrollOnNewData = false;
  @Output() create = new EventEmitter<any>();
  @Output() edit = new EventEmitter<any>();
  @Output() delete = new EventEmitter<any>();
  @Output() rowSelected = new EventEmitter<GridRowSelect>();
  @Output() save = new EventEmitter<void>();
  @Output() imported = new EventEmitter<any>();
  @Output() submittedEvent = new EventEmitter<any>();

  constructor(
    private formlyService: FormlyService,
    private menuService: MenuService,
  ) {}

  ngOnInit() {
    this.getFields();
  }

  get gridStateKey() {
    return `Tabs.${this.stateKey ?? this.header ?? this.name}`;
  }

  private getFields() {
    if (this.showCreate) {
      this.fields.push(this.formlyService.createButton(() => this.create.emit(), { dropdown: this.createDropdown }));
    }

    if (this.showExport) {
      this.fields.push(this.formlyService.exportButton(this.grid, this.name));
    }

    if (this.importService && !this.menuService.isReadOnly) {
      if (this.importDropdown) {
        this.fields.push(
          this.formlyService.importButton(this.importButtonText, (file: any) => this.grid.import(file), {
            dropdown: this.importDropdown,
          }),
        );
      } else {
        this.fields.push(
          this.formlyService.fileUpload(
            this.importButtonText,
            (file: any) => {
              this.grid.import(file);
              this.imported.emit();
            },
            () => this.grid.exportFile(),
            { dropDownText: this.dropDownText },
          ),
        );
      }
    }

    if (this.additionalFields) {
      this.fields.push(...this.additionalFields);
    }
  }
}
